/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import { Col, Container, Row, Breadcrumb, BreadcrumbItem, Spinner, Chip, ChipLabel } from 'design-react-kit';
import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import ApiService from "../../../services/api";
import Page404 from '../../pages/page404';
import { WidgetClass } from '../../pages/models/widget';
import WidgetPageRating from 'pa_kit/apps/page_evaluation/components/widget_page_rating';
import WidgetContacts from 'pa_kit/apps/contacts/components/widget_contacts';
import { ActaAuthContext } from "pa_kit/auth";
import { LocalSettingsContext } from "services/local_settings";
import { PlaceClass } from '../models/place';
import WidgetPlace from './widget_place';
import { CategoryClass } from '../../categories/models/category';
import { Helmet } from "react-helmet-async";
import ShareButtons from 'apps/utils/share_buttons';

const PagePlaceSingle = () => {

    let { categorySlug } = useParams();
    let { placeSlug } = useParams();
    let from = window.location.href;

    const settings = useContext(LocalSettingsContext);
    const auth = useContext(ActaAuthContext);

    const localSettings = settings.localSettings;
    const organization = auth.organization;

    const isActagovWebsiteEditor = auth.user && auth.user.isActagovWebsiteEditor();
    const isActagovContentEditor = auth.user && auth.user.isActagovContentEditor();

    const actagov_config = auth.organization.active_licenses?.services?.actagov;

    const placesParentCategory = localSettings.places_parent_category_data === null ? '' : localSettings.places_parent_category_data.title
    const placesParentCategorySlug = localSettings.places_parent_category_data === null ? '' : localSettings.places_parent_category_data.slug

    const [ place, setPlace ] = useState();
    const [ category, setCategory ] = useState();
    const [ widget, setWidget ] = useState();

    const [ mainSection, setMainSection ] = useState({});

    const [ isLoading, setIsLoading ] = useState(true);
    const [ pageNotFound, setPageNotFound ] = useState(false);

    const fetchCategory = async() => {
        try {
            const category = await ApiService.getCategory(categorySlug);
            setCategory(new CategoryClass(category));
        } catch (error) {
            setPageNotFound(true);
        }       
    }

    const fetchPlace = async() => {
        try {
            const placeData = await ApiService.getPlace(placeSlug);
            setPlace(new PlaceClass(placeData))
            setWidget(new WidgetClass({        
                name: "PlaceContent",
                class: "place-content",
                place_slug: placeSlug  
            }));
            setIsLoading(false);
        } catch (error) {
            setPageNotFound(true);
            console.log(error);
        }        
    }

    const fetchMainSections = async() => {
        const mainSectionsData = await ApiService.getMainSections();
        const mainSection = mainSectionsData.filter(main_section => main_section.id === 8); // Luoghi
        setMainSection(mainSection[0]);
    }

    useEffect(() => {
        fetchCategory();
        fetchPlace();
        fetchMainSections();
    }, []);

    if(pageNotFound) return <Page404 />;
    if(isLoading) return <Container style={{ padding: "50px" }}><Spinner active /></Container>;
    return <>
        <Helmet>
            <title>{place.name + ' | ' + organization.name}</title>
            <meta name="description" content={(place.content.description.description).substring(0, 255).replace(/(<([^>]+)>)/gi, "")} />
        </Helmet>
        <Container fluid className="p-0 places-main-wrapper">
            <Container className="pt-5 pb-5 px-3">
                <Row>
                    <Col>
                    <Breadcrumb>                        
                        <BreadcrumbItem>
                            <a href='/'>Home</a>
                            <span className='separator'>/</span>
                        </BreadcrumbItem>
                        {placesParentCategory !== ''
                            && 
                            <BreadcrumbItem>
                                <a href={'/' + placesParentCategorySlug + '/'}>{placesParentCategory}</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                        }
                        <BreadcrumbItem>
                            <a href='/luoghi/'>{mainSection.name}</a>
                            <span className='separator'>/</span>
                        </BreadcrumbItem>                            
                        <BreadcrumbItem>
                            <a href={'/luoghi/' + (category && category.slug) + '/'}>{category && category.name}</a>
                            <span className='separator'>/</span>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                            {place.name}                                      
                        </BreadcrumbItem> 
                    </Breadcrumb>
                    </Col>
                </Row>
                {isActagovWebsiteEditor && 
                    <Row>
                        <Col className="text-end">
                            <a href={'/admin/edit-place/' + place.slug + '/?from=' + from} className="me-2" title="Modifica">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                    <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                                </svg>    
                            </a>
                        </Col>
                    </Row>
                }
                <Row className="places-wrapper">
                    <Col className="py-2" lg={7}>
                        <h1>{place.name}</h1>
                    </Col>
                    <Col className="pt-5 pt-lg-2" lg={{ offset: 1, size: 4 }}>
                        <ShareButtons url={actagov_config?.frontend_url + 'luoghi/'+ place.category.slug + '/' + place.slug + '/'} title={place.name} />
                        {place.tags.length > 0 &&
                            <Row>
                                <span className="mb-2 small">Argomenti</span>
                            </Row>
                        }
                        {place.tags && place.tags.map((tag) => 
                            <a href={'/argomenti/' + tag.slug} key={tag.id} className="text-decoration-none me-2" title={tag.name}>
                                <Chip simple color='primary'>
                                    <ChipLabel>{tag.name}</ChipLabel>
                                </Chip>
                            </a>
                        )}
                    </Col>
                </Row>
            </Container>

            <WidgetPlace widget={widget} />

            <Container fluid className={'rating-wrapper page-rating places-article-page-rating'} data-element="feedback">
                <WidgetPageRating page_title={place.name} />
            </Container>

            <Container fluid className={'contacts-wrapper places-article-page-contacts'}>
                <WidgetContacts />
            </Container>

        </Container>
    </>;
}

export default PagePlaceSingle;